module.exports = __webpack_public_path__ + "img/slide4.9573d766.png";